import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import {change, Field, getFormValues} from 'redux-form';

import {
	fetchDiscountCode as fetch,
	clearDiscountCode as clear,
	setDiscountCodeAutoRemoved
} from '../store/actions';
import {
	getDiscountCodeResponse,
	isDiscountCodeModuleEnabled,
	isDiscountCodeValid
} from '../store/discountCodeSelector';
import TextInput from './TextInput';
import withLocalize from '../withLocalize';
import T from './Translate';

class DiscountCode extends Component {

	handleSubmit = async () => {
		const { dispatch, formValues, totalPrice } = this.props;
		dispatch(setDiscountCodeAutoRemoved(false));

		const response = await dispatch(fetch());

		if (response && response.discountCode && response.prices) {
			const discountAmount = response.prices[formValues.currency.id] || 0;
			if (discountAmount > totalPrice) {
				// Sleva přesahuje celkovou cenu – nepovolíme aplikovat
				dispatch(clear());
				dispatch(setDiscountCodeAutoRemoved(true));
				return;
			}
		}

		dispatch(change('bookingForm', 'discountCode', formValues.discountCode));
	}

	handleRemove = () => {
		const { dispatch } = this.props;
		dispatch(clear());
		dispatch(change('bookingForm', 'discountCode', ''));
		dispatch(setDiscountCodeAutoRemoved(false));
	}

	render() {
		const {
			formValues,
			translate: t,
			isDiscountCodeModuleEnabled,
			isDiscountCodeValid,
			discountCodeResponse,
			discountCodeAutoRemoved,
			isLoading,
		} = this.props;

		if (!isDiscountCodeModuleEnabled) {
			return null;
		}

		return (
			<fieldset className="fieldset">
				{isDiscountCodeValid ?
					(
						<div className="fieldset__fields-row discount_code">
							<span className="discount_code--valid"><T id="Step4.discountCode.valid" /> <strong style={{marginLeft: '10px'}}>{discountCodeResponse.discountCode}</strong></span>
							<button
								className="button discount_code--valid--remove"
								onClick={this.handleRemove}
							>
							</button>
						</div>
					) : (
						<div className="fieldset__fields-row discount_code">
							<div className="discount_code__field">
								<Field
									component={TextInput}
									name="discountCode"
									id="guest-discountCode"
									label={t('Step4.discountCode')}
								/>
								{((!discountCodeResponse || !discountCodeResponse.discountCode) && discountCodeResponse !== undefined) && (
									<span className="discount_code--invalid"><T id="Step4.discountCode.invalid" /></span>
								)}

								{discountCodeAutoRemoved && !isDiscountCodeValid && (
									<span className="discount_code--invalid"><T id="Step4.discountCode.exceedsTotal" /></span>
								)}
							</div>
							{isLoading ? (
								<div className="discount_code--spinner"
								/>
							) : (
								<button
									className={`button discount_code-button ${!formValues.discountCode ? 'discount_code-button-disabled' : ''}`}
									onClick={this.handleSubmit}
									disabled={!formValues.discountCode}
								>
									{t('Step4.discountCode.submit')}
								</button>
							)}
						</div>
					)
				}
			</fieldset>
		);
	}
}

export default compose(
	connect(state => ({
		formValues: getFormValues('bookingForm')(state),
		isDiscountCodeModuleEnabled: isDiscountCodeModuleEnabled(state),
		isDiscountCodeValid: isDiscountCodeValid(state),
		discountCodeResponse: getDiscountCodeResponse(state),
		discountCodeAutoRemoved: state.app.discountCodeAutoRemoved,
		isLoading: state.app.isLoading,
		totalPrice: state.app.totalPrice,
	})),
	withLocalize,
)(DiscountCode);



// WEBPACK FOOTER //
// ./src/components/DiscountCode.jsx